

















import { Component, Mixins } from "vue-property-decorator";
import { FixedWindowMixin } from "./system/mixins";
import { FooterPane } from "./panes";
import DeveloperIndicator from "./developer/DeveloperIndicator.vue";
import { WindowCloser } from "../system";

@Component({
  components: {
    FooterPane,
    DeveloperIndicator,
  }
})
export default class App extends Mixins(FixedWindowMixin) {
  isClosing: boolean = false;

  mounted() {
    // ウィンドウ内へのファイルのドロップでページが遷移してしまうのを防止する
    // el-dialogの余白に対応するためにwindowでガードさせている
    window.ondragover = (event: DragEvent) => {
      event.stopPropagation();
      event.preventDefault();
      event.dataTransfer.dropEffect = "none";
    };
    window.onkeydown = (event: KeyboardEvent) => {
      /*
        ieでオブジェクトにテキストを入力してescキーを押すと
        フォーカス前の内容に戻るのでescキーのイベントを防止する。(念のためchromeも)

        KeyboardEventのkeyCodeは非推奨、codeはie未対応なのでkeyを使用する
        ただし、keyはieだと"Esc"、chromeだと"Escape"と差がある
        https://developer.mozilla.org/ja/docs/Web/API/KeyboardEvent

        escが効いてほしいところがあるならその範囲でイベントの伝搬を止めればいいので全体ガードしている
      */
      if (event.key === "Esc" || event.key === "Escape") {
        event.stopPropagation();
        event.preventDefault();
      }
      /*
        文書編集中にリロードすると、文書編集画面起動時の文書編集Tokenが残ったまま、新たに文書編集Tokenを払い出してしまう
        それにより、自端末でしか編集していないのに複数Tokenが存在することとなり、ロックがかかってしまう
        また、リロードが可能だと意図せず文書の編集内容を破棄してしまう可能性があるためリロードをガードする
      */
      if (WindowCloser.shouldConfirmToClose() && this.isReloadRequested(event)) {
        event.stopPropagation();
        event.preventDefault();
      }
    };
    // 右クリックコンテキストメニューの非表示
    window.oncontextmenu = () => false;

    // テーマの設定
    document.body.setAttribute("data-docu-style", this.$configuration.style.theme);

    window.addEventListener("message", this.onMessageReceived, false);
  }

  isReloadRequested(event: KeyboardEvent): boolean {
    return event.key === "F5" || (event.ctrlKey && (event.key === "r" || event.key === "R"));
  }

  private onMessageReceived(event: any): void {
    try {
      this.$logger.debug(event.data);
      const message = JSON.parse(event.data) as { key: string };
      if (message.key === "closeWindow") {
        this.close();
      }
    } catch {}
  }

  async close(): Promise<void> {
    if (this.isClosing) { return; }
    this.isClosing = true;
    try {
      await this.$closeWindow();
    } finally {
      this.isClosing = false;
    }
  }
}
